/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Enrich_Inline_HintInputs */

const en_directory_submit_enrich_inline_hint = /** @type {(inputs: Directory_Submit_Enrich_Inline_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Watch the form fill as stages complete. Typically 1–2 minutes; you can stay on this page.`)
};

const zh_directory_submit_enrich_inline_hint = /** @type {(inputs: Directory_Submit_Enrich_Inline_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`各阶段完成后表单会实时填充。通常需要 1–2 分钟，请留在此页。`)
};

/**
* | output |
* | --- |
* | "Watch the form fill as stages complete. Typically 1–2 minutes; you can stay on this page." |
*
* @param {Directory_Submit_Enrich_Inline_HintInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_enrich_inline_hint = /** @type {((inputs?: Directory_Submit_Enrich_Inline_HintInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Enrich_Inline_HintInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_enrich_inline_hint(inputs)
	return zh_directory_submit_enrich_inline_hint(inputs)
});
export { directory_submit_enrich_inline_hint as "directory.submit.enrich.inline_hint" }